import { useState, useEffect } from "react";
import InputField from "./InputField";
import { fetchAuthors, resetAuthors } from "../../store/search-actions";
import { useSelector, useDispatch } from "react-redux";
import SearchLoader from "./SearchLoader";
import DeleteIcon from "./DeleteIcon";
import FacetIcon from "./FacetIcon";

const AuthorSearch = (props) => {
  const dispatch = useDispatch();
  // states
  const [isOpen, setIsOpen] = useState(false);
  const [inputValue, setInputValue] = useState({ searchText: "" });
  const { searchText } = inputValue;
  const authors = useSelector((state) => state.search.authors);
  const loadingAuthors = useSelector((state) => state.search.loadingAuthors);

  // methods
  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputValue((prev) => ({
      ...prev,
      [name]: value
    }));
  };
  const checkIfActive = (f) => {
    if(!props.selections['authors']) { 
      return false 
    } else {
      return props.selections['authors'].includes(f)
    }
  }
 /*  const handleAuthor = (val) => {
    dispatch(searchActions.setprops.selections(val));
  };
 */
  const handleAuthor =  (val) => props.filtersHandler(props.id, val);
  useEffect(() => {
    const identifier = setTimeout(() => {
      //props.setField(inputValue.searchText)
      if (searchText.length < 1) {
        dispatch(resetAuthors());
      } else {
        dispatch(fetchAuthors(searchText));
      }
    }, 500);
    return () => {
      clearTimeout(identifier);
    };
    // eslint-disable-next-line
  }, [inputValue]);
  return (
    <div className="w-full border-b-[1px] border-b-black border-dotted ">
      <div className="w-full flex flex-row justify-between items-center py-5">
        <span className="font-bold uppercase text-filter-title whitespace-nowrap">{props.label}</span>
        <span className={`transition-all duration-400 cursor-pointer ${isOpen ? '-rotate-45' : ''}`} onClick={() => setIsOpen(!isOpen)}><FacetIcon/></span>
      </div>
      {isOpen ? (
        <div className="flex flex-col items-start justif-start uppercase w-full pb-2.5">
          <div className="py-2 border-[0.5px] border-black border-solid w-full rounded">
            <InputField
              className="flex growth"
              type="text"
              value={searchText}
              placeholder="Type an author..."
              name="searchText"
              onChange={handleChange}
              noPadding={true}
            />
          </div>
          {loadingAuthors ? (
            <div className="w-full flex items-center justify-center">
              <SearchLoader />
            </div>
          ) : authors.length || props.selections['authors']?.length ? (
            <div className="h-[150px] w-full overflow-y-auto">
              {props.selections['authors']?.length
                ? props.selections['authors'].map((sa) => (
                    <div
                      className="cursor-pointer w-full p-2 border-[0.5px] border-b-black border-b-dotted text-left bg-primary text-white hover:opcaity-70 hover:font-bold flex flex-row items-center justify-between"
                      key={sa}
                      onClick={() => handleAuthor(sa)}
                    >
                      {sa}<DeleteIcon />
                    </div>
                  ))
                : null}

              {authors
                .filter((o) => !checkIfActive(o.toLowerCase()))
                .map((a) => (
                  <div
                    className="cursor-pointer w-full p-2 border-[0.5px] border-b-black border-b-dotted text-left hover:text-primary hover:font-bold"
                    key={a}
                    onClick={() => handleAuthor(a)}
                  >
                    {a}
                  </div>
                ))}
            </div>
          ) : null}
          {searchText.length && !authors.length ? (
            <div>Try with another author</div>
          ) : null}
          {searchText.length < 1 ? (
            <div className="text-left">Type an author's name or surname</div>
          ) : null}
          <div></div>
        </div>
      ) : null}
    </div>
  );
};

export default AuthorSearch;
